import React from 'react'

import facebook from '../../assets/facebook.png';
import twitter from '../../assets/twitter.png';
import instagram from '../../assets/instagram.png';

import logo from '../../assets/logo.svg'
import { Link } from 'react-router-dom';
const Footer = () => {
    return (
        <>
        <div className="socials">
          <ul>
            <li><img src={facebook}  alt="facebook"/></li>
            <li><img src={twitter} alt="twitter"/></li>
            <li><img src={instagram} alt="instagram"/></li>
          </ul>
        </div>
        <footer>
            <div className="main-footer">
                <img src={logo} className="footer-logo" alt="footer-lolgo" />
                <div className="footer-menu">
                <ul>
                    <li><Link to={"/"}>Buy gift cards</Link></li>
                    <li><Link to={"/products"}>Catalog</Link></li>
                    <li><Link to={"/support"}>Support</Link></li>
                    {/* <li>Promo</li> */}
                    {/* <li>Deals</li> */}
                    {/* <li>Blog</li> */}
                    <li>Terms and conditions</li>
                    <li>Privacy policy</li> 
                </ul>
                </div>

                <p> ©2021 Gift swap, Inc. All Rights Reserved. </p>
            </div> 
        </footer>
        </>
    )
}

export default Footer
